<template> </template>

<script>
import { logOutRequired, removeCorrelationId } from '../../lib/UserSession.js';

export default {
  name: 'Logout',
  data: function() {
    return {};
  },
  mounted: async function() {
    // Logout
    if (this.$auth) {
      let logoutRequired = await logOutRequired();

      // this will signout the user out of the OKTA session and clear the TOKENS locally
      // From documentation this will use the postLogoutRedirectUri to redirect the user to the Homepage
      // we can pass the state to display a message
      try {
        // If session timed out we want to redirect the user after the flow went to OKTA with a message we can catch on the UI
        if (logoutRequired) {
          await this.$auth.oktaAuth.signOut({ state: 'SessionTimedOut' });
        } else {
          await this.$auth.oktaAuth.signOut({ state: 'Logout' });
        }

        // this will also remove the Correlation ID use for debugging
        removeCorrelationId();
        
      } catch (ex) {
        // Log the error and redirect
        if(this.$logger && typeof(this.$logger)!=='undefined'){
          this.$logger.error('Logout - Mounted:', ex);
        }
        if (logoutRequired) {
          this.$router.replace({
            path: '/login',
            query: { state: 'SessionTimedOut' },
          });
        } else {
          this.$router.replace({
            path: '/login',
            query: { state: 'Logout' },
          });
        }
      }
    } else {
      // just in case $auth is not setup correctly - redirect user to login page
      this.$router.replace({
        path: '/login',
        query: { state: 'Logout' },
      });
    }
  },
};
</script>

<style lang="scss" scoped></style>
